import {createFileRoute} from '@tanstack/react-router';

import {Home} from '@/features/Home/components/Home';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute('/_b/_p/')({
  component: Home,
  beforeLoad: () => makeDocumentTitle('Qii Studio - Picture Reality.', true),
});
